import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#DFE8F9",
      d: "M17.13 5.01c2.56-.16 4.69 1.52 4.87 3.84v9.8c-.13 1.83-1.6 3.39-3.57 3.77-2.76.52-5.33-1.35-5.43-3.9V8.99c.05-2.04 1.88-3.84 4.13-3.98"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#2B63D9",
      d: "M6.5 15.75a.75.75 0 0 1 1.5 0c0 4.646 3.613 8.37 8 8.37s8-3.715 8-8.37a.75.75 0 0 1 1.5 0c0 5.425-4.227 9.87-9.5 9.87s-9.5-4.456-9.5-9.87"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#2B63D9",
      d: "M15.25 27.88V25a.75.75 0 0 1 1.5 0v2.88a.75.75 0 0 1-1.5 0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#2B63D9",
      d: "M22.25 27.5a.75.75 0 0 1 0 1.5H9.75a.75.75 0 0 1 0-1.5zM15.65 3.01c2.96-.16 5.42 2.03 5.6 4.98V17c-.12 2.52-2.05 4.63-4.55 4.95a5.26 5.26 0 0 1-5.95-5.11v-8.7c.04-2.69 2.21-5 4.9-5.14z"
    }, null, -1)
  ]))]))
}
export default { render: render }